
import { useTranslation } from 'react-i18next';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    document.documentElement.lang = newLang;
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-300 border border-white/20 backdrop-blur-sm whitespace-nowrap"
      aria-label="Toggle Language"
    >
      <i className="ri-translate-2 text-lg"></i>
      <span className="font-medium text-sm">
        {i18n.language === 'en' ? 'ع' : 'En'}
      </span>
    </button>
  );
};

export default LanguageToggle;
